import classNames from "classnames/bind";
import DynamicPhoneNumber from "common/blocks/DynamicPhoneNumber";
import UIIcon from "common/blocks/UIIcon";
import SmartLink from "common/wrapper/SmartLink";
import type { ResolvedSocialLink } from "resolvers/base/footerSocialLinkResolver";

import styles from "./FooterSocialSection.module.scss";

const cx = classNames.bind(styles);

export type FooterSocialSectionProps = {
    socialContent: ResolvedSocialLink[];
    text: string;
    prefetch?: boolean;
};

const FooterSocialSection: React.FC<FooterSocialSectionProps> = ({
    socialContent,
    text,
    prefetch = false,
}) => (
    <div className={cx("contactBar")}>
        <div className={cx("contactBarWidthContain")}>
            <div className={cx("contactNumber")}>
                <p className={cx("numberText")}>
                    Call{" "}
                    <span className={cx("numberWrapper")}>
                        <DynamicPhoneNumber isLink className={cx("numberLink")} />
                    </span>
                </p>
            </div>
            <div className={cx("socialsText")}>{text}</div>
            <div className={cx("socials")}>
                <ul className={cx("socialsList")}>
                    {!!socialContent?.length &&
                        socialContent.map(({ link, platform, uiIcon }) => (
                            <li key={platform} className={cx("socialsListItem")}>
                                <SmartLink href={link} prefetch={!!prefetch}>
                                    <a
                                        target="_blank"
                                        className={cx("socialsListItemLink", `link${uiIcon.icon}`)}
                                        rel="noopener noreferrer"
                                        aria-label={platform}
                                    >
                                        <UIIcon {...uiIcon} />
                                    </a>
                                </SmartLink>
                            </li>
                        ))}
                </ul>
            </div>
        </div>
    </div>
);

export default FooterSocialSection;
